import { type Address } from './address';
import { type RatePackage } from './rate-package';
import { type StopServiceRequest } from '../../shared/models/stop-service-request';
import { type SSMRateOperand } from './csr';
import { type ServiceAddress } from './service-address';

export class StartServiceRequest {
  AccountNumber?: string; // in account detail
  ActionTypeCode?: string;
  AuthenticatedIndicator?: string;
  PromoCode?: string; // only seasonal reconnect
  PastDueBalance?: number; // in account details
  SalesChannel?: string; // in enrollments either 'MOBILE' if mobileview OR 'WEB'
  SaId?: string; // acount detail in ServiceAddresses array
  AddressFlag?: string;
  StartServiceType?: string; // either 'TO' or 'MKSW'
  PremiseId?: string;
  AGLPremiseId?: string;
  Address1?: string;
  City?: string;
  State?: string;
  ZipCode?: string;
  CustomerClass?: string; // in account details
}

export class SSMProcessData {
  StartRequest?: StartServiceRequest;
  CurrentProcess?: string;
  UseServiceAddressAsMailingAddress?: boolean;
  MailingAddress?: Address;
  FirstAvailable?: boolean;
  Date?: string;
  Time?: string;
  RatesResponse?: SSMRatesResponse;
  PackageIsOPP?: boolean;
  CustomerServiceFee?: string;
  DiscountCode?: string;
  PricePerTherm?: string;
  ProductTerm?: string;
  PlanType?: string;
  StopRequest?: StopServiceRequest;
  SaturdayIfAvailable?: boolean;
  StopServiceAddress?: string;
  StartServiceAddress?: ServiceAddress;
  UseNewMailingAddressOnAllAccounts?: boolean;
}

export class SSMRatesResponse {
  RatePackageId?: number;
  OrderId?: string;
  OrderType?: string;
  PromoCode?: string;
  Address1?: string;
  ExternalAccountId?: string;
  BankName?: string;
  CardExpDate?: string;
  CardNumber?: string;
  CardType?: string;
  RatePackages?: RatePackage[];
  AuthorizedUsers?: string;
  EligibilityOperands?: SSMRateOperand[];
}
